import { createSlice } from '@reduxjs/toolkit';
import { fetchContactInfo } from '../actions/contactAction';
import { submitContactUs } from '../actions/contactAction';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchContactInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchContactInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Failed to fetch contact info';
      });
  },
});

const initialContactUsState = {
  isLoading: false,
  isSuccess: false,
  error: null,
};

export const contactUsSlice = createSlice({
  name: 'contactUs',
  initialState: initialContactUsState,
  reducers: {
    resetContactUs: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactUs.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(submitContactUs.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(submitContactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload || 'حدث خطأ أثناء الإرسال';
      });
  },
});

export const { resetContactUs } = contactUsSlice.actions;

export default contactSlice.reducer; 